import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/groups',
  component: Management,
  redirect: '/groups/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/groups/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listGroups
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/groups/ListTable'),
          meta: {
            auth: Auth.listGroups,
            tabName: 'all'
          }
        },
        {
          path: 'enterprise_group',
          component: () => import('@/views/groups/ListTable'),
          meta: {
            auth: Auth.listGroups,
            tabName: 'enterprise_group'
          }
        },
        {
          path: 'family_group',
          component: () => import('@/views/groups/ListTable'),
          meta: {
            auth: Auth.listGroups,
            tabName: 'family_group'
          }
        },
        {
          path: 'community_group',
          component: () => import('@/views/groups/ListTable'),
          meta: {
            auth: Auth.listGroups,
            tabName: 'community_group'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/groups/New'),
      meta: {
        auth: Auth.createGroup
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/groups/Edit'),
      meta: {
        auth: Auth.editGroup
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/groups/DetailLayout'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/groups/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showGroup
          }
        },
        {
          path: 'group_applications',
          component: () => import('@/views/groups/details/GroupApplications.vue'),
          meta: {
            auth: Auth.listGroupApplicationsOfGroup
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/groups/details/Orders.vue'),
          meta: {
            auth: Auth.listOrdersOfGroup
          }
        },
        {
          path: 'transaction_records',
          component: () => import('@/views/groups/details/TransactionRecord.vue'),
          meta: {
            auth: Auth.listGroupTransactionRecordsOfGroup
          }
        }
      ]
    }
  ]
}
